import {PaymentCurrencyType, QueryWalletArgs, WalletEntityType} from "@irati/types"
import authentication from "@irati/auth"
import {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

export function walletVariables(props: WithPerkOrReward): QueryWalletArgs | null {
  const userId =  authentication.user().uuid!
  const fpWallet = () => ({userId, entityType: WalletEntityType.User, currency: PaymentCurrencyType.Tt})
  const rpWallet = () => ({userId, entityType: WalletEntityType.User, currency: PaymentCurrencyType.Rp})
  const cashWallet = () => ({userId, entityType: WalletEntityType.User, currency: PaymentCurrencyType.Gbp})

  // over-ride to rp wallet if they are browsing rewards but not in admin section
  if (props.isRewards && !props.isWallet) {
    return rpWallet()
  }

  if (authentication.apps("wallet.treatTokens")) {
    return fpWallet()
  } else if (authentication.apps("wallet.users")) {
    return cashWallet()
  } else if (authentication.apps("wallet.flexiRewards")) {
    return rpWallet()
  }

  return null
}
